import { Vue } from "vue-property-decorator";
var defaultState = {
    identity: null,
    currentUser: null,
    events: [],
    selectedOrganization: null,
    selectedEvent: null,
    page: { title: "", showTopNav: true },
    popup: { title: "", description: "", visible: false },
    globalSettings: {
        permissionText: "",
        mobileInstructions: "",
        paymentMinPerRepeat: 0,
        paymentMinManual: 0,
        publicRulesDescription: "",
        mobilePrivacyInfo: "",
    },
};
var vm = new Vue({
    data: { state: defaultState }
});
export var store = vm.$data.state;



//////////////////
// WEBPACK FOOTER
// ./app/ts/store.ts
// module id = 3
// module chunks = 0